import { Fragment, useState } from 'react'
import {
  Row,
  Stack,
  Col,
  Container,
  Heading,
  Card,
  Text,
  useModal
} from '@leroy-merlin-br/backyard-react-ui'

import DocumentPro from 'scripts/react-components/lmcv-pro/components/DocumentPro'

import handleModal from 'lmcv/pages/Customers/handleModal'
import { CardHeader } from 'lmcv/components/Card'

import * as S from './styled'

const JoinProfessional = ({ status, hasProfessionalRelationship }) => {
  const { setModal } = useModal()

  const [drawerVisibility, setDrawerVisibility] = useState(false)
  const isNotEligibleToEAD = status === 10 && hasProfessionalRelationship

  const showDrawer = () => {
    isNotEligibleToEAD
      ? handleModal(setModal)
      : setDrawerVisibility(true)
  }

  const closeDrawer = () => setDrawerVisibility(false)

  const onSubmit = () => document.location.reload()

  const onCatch = () => {
    closeDrawer()
    handleModal(setModal)
  }

  return (
    <Fragment>
      <Card>
        <CardHeader title="Clientes" />

        <S.Body>
          <S.Image
            src={`${
              window && window.env.assetHost
            }assets/images/lmcvNew/locked_clients.png`}
          />
          <Stack spacing="kilo">
            <Heading size="tera" noMargin>
              Essa área é exclusiva para Profissionais
            </Heading>
            <Text size="kilo" noMargin>
              Para ter acesso a essa área você precisa enviar seus
              documentos para validação
            </Text>
          </Stack>

          <Container>
            <Row justify="center">
              <Col size={{ giga: 4 }}>
                <S.Button
                  onClick={showDrawer}
                  color="green"
                  isStretch
                  size="mega"
                >
                  Enviar documentos
                </S.Button>
              </Col>
            </Row>
          </Container>
        </S.Body>
      </Card>

      <DocumentPro
        open={drawerVisibility}
        onClose={closeDrawer}
        onCancel={closeDrawer}
        onFinish={onSubmit}
        onCatch={onCatch}
      />
    </Fragment>
  )
}

export default JoinProfessional
